module.exports = __webpack_public_path__ + "img/mascotas.cafc80b1.svg";